import PropTypes from "prop-types";
import styles from "./CitationModal.module.scss";
import useCitationModalLogic from "../../hooks/useCitationModalLogic";
import CitationContent from "./CitationContent";

const CitationModal = (props) => {
  const {
    citationNumber,
    displayText,
    fallbackUrl,
    hasPubMed,
    handlePubMedClick,
    handleUrlClick,
    multipleCitations: processedMultipleCitations,
    hasMultipleCitations,
    handleClose,
    handleViewAllReferences,
    getClassNames,
  } = useCitationModalLogic(props);

  const classNames = getClassNames(styles);

  if (hasMultipleCitations && processedMultipleCitations?.length > 0) {
    return (
      <div className={styles["citation-modal-container"]}>
        <div className={styles["citation-popup"]}>
          <div className={styles["content-row"]}>
            <div className={`bold ${styles["popup-title"]}`}>References</div>
            <div className={styles["close-icon"]} onClick={handleClose}>
              <i className="tg-icons-Cross"></i>
            </div>
          </div>

          <div className={styles["reference-content"]}>
            <div className={styles["citation-popup-content"]}>
              {processedMultipleCitations.map((citation, index) => (
                <div key={citation.number || index} className={styles["citation-entry"]}>
                  <CitationContent
                    citationNumber={citation.number}
                    displayText={citation.displayText}
                    fallbackUrl={citation.fallbackUrl}
                    hasPubMed={citation.hasPubMed}
                    onPubMedClick={citation.handlePubMedClick}
                    onUrlClick={citation.handleUrlClick}
                    onViewAllReferences={handleViewAllReferences}
                    styles={styles}
                    classNames={classNames}
                    showCitationNumber={true}
                    hidePubMedWhenEmpty={true}
                    viewAllButtonText=""
                  />
                  {index < processedMultipleCitations.length - 1 && (
                    <div className={styles["citation-separator"]}></div>
                  )}
                </div>
              ))}
              <div className={styles["citation-navigation"]}>
                <button
                  className={styles["view-all-references-link"]}
                  onClick={handleViewAllReferences}
                >
                  View all references
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles["citation-modal-container"]}>
      <div className={styles["citation-popup"]}>
        <div className={styles["content-row"]}>
          <div className={`bold ${styles["popup-title"]}`}>Reference</div>
          <div className={styles["close-icon"]} onClick={handleClose}>
            <i className="tg-icons-Cross"></i>
          </div>
        </div>

        <div className={styles["reference-content"]}>
          <div className={styles["citation-popup-content"]}>
            <CitationContent
              citationNumber={citationNumber}
              displayText={displayText}
              fallbackUrl={fallbackUrl}
              hasPubMed={hasPubMed}
              onPubMedClick={handlePubMedClick}
              onUrlClick={handleUrlClick}
              onViewAllReferences={handleViewAllReferences}
              styles={styles}
              classNames={classNames}
              showCitationNumber={true}
              hidePubMedWhenEmpty={true}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

CitationModal.propTypes = {
  citationNumber: PropTypes.number,
  citationText: PropTypes.string,
  fullReferenceText: PropTypes.string,
  multipleCitations: PropTypes.arrayOf(
    PropTypes.shape({
      number: PropTypes.string.isRequired,
      fullReferenceText: PropTypes.string.isRequired,
    }),
  ),
  onClose: PropTypes.func.isRequired,
  onViewAllReferences: PropTypes.func.isRequired,
};

export default CitationModal;
